function createGradient(ctx) {
    const gradient = ctx.createLinearGradient(0, 0, 0, 300);
    gradient.addColorStop(0, 'RGBA(23,194,137,0.9)');
    gradient.addColorStop(1, 'RGBA(23,194,137,0)');
    return gradient;
}

export const getPerformanceChartConfig = (barData, lineData, title, labels, canvasCtx, onBarClick, highlightedBucketIndex = null) => {
    const gradient = canvasCtx ? createGradient(canvasCtx) : 'RGBA(23,194,137,0.5)';

    const isHighlighted = highlightedBucketIndex !== null;
    const barBg = isHighlighted
        ? barData.map((_, i) =>
            i === highlightedBucketIndex
                ? 'rgba(13, 107, 79, 0.95)'
                : 'rgba(23, 194, 137, 0.35)'
        )
        : gradient;
    const barBorderColor = isHighlighted ? 'transparent' : '#17C289';

    return {
        type: 'line',
        data: {
            labels: labels,
            datasets: [
                {
                    type: 'bar',
                    label: 'Distinct %',
                    data: barData,
                    borderColor: barBorderColor,
                    cubicInterpolationMode: 'monotone',
                    fill: true,
                    backgroundColor: barBg,
                },
                {
                    type: 'line',
                    label: 'Cumulative %',
                    data: lineData,
                    borderColor: '#17C289',
                    backgroundColor: 'RGBA(23,194,137,0)',
                    tension: 0.9,
                    pointRadius: 4,
                    cubicInterpolationMode: 'monotone',
                }
            ]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            onClick: onBarClick
                ? (_evt, elements, chart) => {
                    if (!elements?.length) return;
                    const barEl = elements.find(e => chart.getDatasetMeta(e.datasetIndex).type === 'bar');
                    if (barEl) onBarClick(barEl.index);
                }
                : undefined,
            onHover: onBarClick
                ? (evt, elements) => {
                    const target = evt?.native?.target;
                    if (target) target.style.cursor = elements?.length ? 'pointer' : 'default';
                }
                : undefined,
            plugins: {
                title: {
                    display: true,
                    position: 'bottom',
                    align: 'center',
                    text: title,
                },
                legend: {
                    display: false,
                },
                tooltip: {
                    mode: 'index',
                    displayColors: false,
                    padding: 10,
                    callbacks: {
                        label: function (context) {
                            let label = context.dataset.label || '';
                            let value = Number(context.parsed.y).toFixed(2) + '%';
                            return label + ': ' + value;
                        }
                    }
                },
                interaction: {
                    intersect: true,
                    mode: 'index',
                },
                spanGaps: true,
            },
            interaction: {
                intersect: false,
            },
            scales: {
                x: {
                    border: { display: true },
                    display: true,
                    grid: {
                        display: true,
                        color: '#F7F9FA',
                    },
                },
                y: {
                    border: { display: true },
                    display: true,
                    ticks: {
                        display: true,
                        stepSize: 25,
                        callback: function (value) {
                            return value + '%';
                        },
                    },
                    suggestedMin: 0,
                    suggestedMax: 100,
                    position: 'right',
                    grid: {
                        drawBorder: false,
                        display: true,
                        color: '#F7F9FA',
                    },
                },
            },
            animation: {
                delay: (context) => {
                    let delay = 0;
                    if (context.type === 'data' && context.mode === 'default') {
                        let distanceFromBottom = context.chart.chartArea.bottom - context.parsed.y;
                        delay = distanceFromBottom * 5;
                    }
                    return delay;
                }
            },
        },
        plugins: [{
            afterDraw: chart => {
                if (chart.tooltip?._active?.length) {
                    let x = chart.tooltip._active[0].element.x;
                    let yAxis = chart.scales.y;
                    let ctx = chart.ctx;
                    ctx.save();
                    ctx.beginPath();
                    ctx.moveTo(x, yAxis.top);
                    ctx.lineTo(x, yAxis.bottom);
                    ctx.lineWidth = 1;
                    ctx.strokeStyle = '#ccc';
                    ctx.stroke();
                    ctx.restore();
                }

                let ctx = chart.ctx;
                let data = chart.data.datasets[0].data;
                data.forEach((value, index) => {
                    let meta = chart.getDatasetMeta(0).data[index];
                    if (chart.getDatasetMeta(0).type === 'bar') {
                        ctx.fillStyle = (highlightedBucketIndex !== null && index === highlightedBucketIndex && value >= 10)
                            ? '#FFFFFF'
                            : '#4A4A4A';
                        ctx.textAlign = 'center';
                        let text = Number(value).toFixed(1) + '%';
                        if (value >= 10) {
                            ctx.fillText(text, meta.x, meta.y + 20);
                        } else {
                            ctx.fillText(text, meta.x, meta.y - 10);
                        }
                    }
                });
            }
        }]
    };
};
